import { GetStateResult, getResultFromState } from "@spry/campaign-client";

export const isLocal = !process.env.REACT_APP_ENV;
export const local_campaignState: GetStateResult | null = getResultFromState(
  "open",
  null
);
